import moment from 'moment'

export default {
    computed: {
        getRegistrarRegistrationDateForRuleBuilder(){
           return {registrarRegistrationDate: moment()}  
        },
        getRegistrationTypeForRuleBuilder(){
           return {registrationType: this.$store.getters['registration/getRegistrationType']}
        },
        getRegistrarQuestionsForRuleBuilderEvaluator(){
            return this.$store.getters['registration/getRegistrarQuestionsForRuleBuilderEvaluator']
        },
        getInvoiceRecipientDataForRuleBuilderEvaluator(){
            return this.$store.getters['registration/getInvoiceRecipientDataForRuleBuilderEvaluator']
        },
        getCaregiverForRuleBuilderEvaluator(){
            return this.$store.getters['registration/getCaregiverForRuleBuilderEvaluator']
        },
    },
    methods: {
        getQuestionsForRuleBuilderEvaluator(personKey){
            return this.$store.getters['registration/getQuestionsForRuleBuilderEvaluator'](personKey)
        },
        getPersonDataForRuleBuilderEvaluator(personKey){
            return this.$store.getters['registration/getPersonDataForRuleBuilderEvaluator'](personKey)
        },
    }
}